import { Accordion, AccordionDetails, styled } from "@mui/material";

export const TaskAccordion = styled(Accordion)(({ theme }) => ({
  background: "none",
  border: `1px solid ${theme.palette.grey[400]}`,
})) as typeof Accordion;

export const TaskAccordionDetails = styled(AccordionDetails)(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "40px",
  padding: "20px",
})) as typeof AccordionDetails;
